/**
 * ナビ固定
 *
 */
const stickyNav = () => {
	const header = document.querySelector("#masthead");
	const headerHeight = header.offsetHeight;
	let adminBarHeight = 0;
	const adminBar = document.getElementById("wpadminbar");
	if (adminBar) {
		adminBarHeight = adminBar.offsetHeight;
	}
	let lastScrollY = window.scrollY;
	window.addEventListener("scroll", function () {
		const currentScrollY = window.scrollY;
		if (currentScrollY === 0) {
			// 一番上に戻ったらすべて外す
			header.classList.remove("sticky-header");
			header.classList.remove("before-sticky");
			header.style.top = adminBarHeight + "px";
		} else if (currentScrollY > lastScrollY) {
		// 下スクロール：隠す
			header.classList.add("before-sticky");
			header.style.top = "";
		} else {
		// 上スクロール：表示（固定）
			header.classList.add("sticky-header");
			header.classList.remove("before-sticky");
			header.style.top = adminBarHeight + "px";
		}
		lastScrollY = currentScrollY;
	});
};
export default stickyNav;
